<script>
export default {
	computed: {
		errorMessage () { return this.$store.state.databaseSearch.errorMessage }
	}
}
</script>

<template lang="html">
  <div class="Message Message--error">
    <div class="l-padding">
      <div class="l-wrap">
        <p v-html="errorMessage"></p>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// error-message.vue?0f32b624